export default function SmallClaimsSection() {
  const features = [
    {
      number: '01',
      title: 'Document Preparation',
      items: [
        'Small claims complaints',
        'Proof of service forms',
        'Filing instructions',
      ],
    },
    {
      number: '02',
      title: 'Court Filing Assistance',
      items: [
        'Court assignment management',
        'Filing fee calculation',
        'Deadline tracking',
      ],
    },
    {
      number: '03',
      title: 'Document Management',
      items: [
        'Scan and upload',
        'Secure cloud storage',
        'Instant access',
      ],
    },
  ];

  return (
    <section className="py-24 bg-[#faf8f5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-gray-200 rounded-full mb-4">
            <span className="text-sm font-medium text-gray-700">Specialized Services</span>
          </div>
          <h2 className="text-5xl font-bold text-[#1a2b4a] mb-4">
            Small Claims Court Document Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Complete document preparation and filing services for small claims cases, from initial complaint to final proof of service
          </p>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-lg p-8 shadow-md">
              <div className="inline-block px-4 py-2 bg-[#1a2b4a] text-white text-sm font-bold rounded-lg mb-6">
                {feature.number}
              </div>
              <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6">{feature.title}</h3>
              <ul className="space-y-4">
                {feature.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-lg mt-0.5"></i>
                    <span className="text-sm text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
